export default function XML_Server() {
  return (
    <div>
      <h1>XML_Server</h1>
      <p>This is the XML_Server component.</p>
    </div>
  );
}